import { baseConfig, RuntimeConfig } from 'config/config.types';

export const config: RuntimeConfig = {
  ...baseConfig,
  env: 'pcm-uat2',
  gravityEnabledByDefault: true,
};
